const lazyFooterBg = () => {
  const barbaContainer = document.querySelector('[data-barba="container"]')
  const footer = document.querySelector('[data-footer]')
  if (barbaContainer && footer) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          footer.style.backgroundImage = footer.dataset.lazyBg
        }
      })
    })
    const div = document.createElement('div')
    barbaContainer.appendChild(div)
    observer.observe(div)
  }
}

export default lazyFooterBg
